import { Auth0ZoneTypeSchema, DeprecatedAuth0ZoneTypeSchema } from "@eigtech/auth0-types";
export const PortalZoneSchema = Auth0ZoneTypeSchema;
export const portalZone = PortalZoneSchema.enum;
export const DeprecatedPortalZoneSchema = DeprecatedAuth0ZoneTypeSchema;
export const DeprecatedPortalZone = PortalZoneSchema.enum;
